<mat-table
  [dataSource]="items"
  [trackBy]="trackBy"
  matSort
  matSortDisableClear
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.name' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="tag-name">{{ item.name }}</span>
      <small class="tag-count muted-text">({{ item.count | fsNumber }})</small>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="owner">
    <mat-header-cell *matHeaderCellDef>{{ 'common.owner' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-object-owner [object]="item"></sn-object-owner>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="sharing">
    <mat-header-cell *matHeaderCellDef>{{ 'common.sharing' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-object-share-status [object]="item"></sn-object-share-status>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef>{{ 'common.actions' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <sn-action-list [items]="actions" [context]="item" alwaysExpand></sn-action-list>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    matRipple
    [@snFadeIn]
    [@snFadeOut]
    (click)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
</mat-table>
